import { createClient } from '@supabase/supabase-js'

const supabase = createClient(
  "https://sptllbxlzxzhtupqfidg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNwdGxsYnhsenh6aHR1cHFmaWRnIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzkzMTg1NDEsImV4cCI6MTk5NDg5NDU0MX0.mM1DcztDOKGYJ9JiZnbHFe_Kgnmn27RvaOFjCfcdppM"
)

export { supabase }
